import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Consts } from "../../pages/consts";
import { intakeDosageUnits, intakeFrequencyUnits } from "../../../resources/json/jsons";

const IntakesFrequencyAndDosageUnit = ({selectedDrug, setSelectedDrug}) => {
  const { t: t } = useTranslation();

  const handleChangingDosageUnit = (value) => {
    const newIntakes = selectedDrug?.intakes?.map(intake => ({...intake, dosageUnit: value})) || [];
    setSelectedDrug({...selectedDrug, intakes: newIntakes, dosageUnit: value});
  }

  return (
    <>
      <div className="w3-row w3-padding-small">
        <div className="w3-col w3-half">
          <div style={{ display: "flex", alignItems: "right"}}>
            <label className="w3-padding">{t("frequency")}*:</label>
            <div className="flex-aligned-items">
              <label>{t("every")?.toLowerCase()}</label>
              <span className="empty-space" />
              <input
                value={selectedDrug?.frequency}
                type={Consts.NUMBER}
                min="0"
                className="form-input label-margin-left"
                onChange={(e) => setSelectedDrug({...selectedDrug, frequency: e.target.value})}
              />
              <span className="empty-space" />
              <Select
                id={Consts.FREQUENCY_UNIT}
                options={intakeFrequencyUnits}
                value={intakeFrequencyUnits?.filter(
                  (option) => option?.value === selectedDrug?.frequencyUnit,
                )}
                formatOptionLabel={(o) => t(o?.label)}
                onChange={({ value }) => setSelectedDrug({...selectedDrug, frequencyUnit: value})}
                placeholder={t("select")}
                className="custom-select"
                classNamePrefix="custom-select"
              />
            </div>
          </div>
        </div>
        <div className="w3-col w3-half">
          <div style={{ display: "flex", alignItems: "right"}}>
            <div className="w3-col s4">
              <label className="w3-padding">{t("dosage_unit")}*:</label>
            </div>
            <div className="w3-col s4">
              <Select
                id={Consts.STRENGTH_UNIT}
                value={intakeDosageUnits?.filter(
                  (option) => option?.value === selectedDrug?.dosageUnit,
                )}
                options={intakeDosageUnits}
                formatOptionLabel={(o) => t(o?.label)}
                name={Consts.STRENGTH_UNIT}
                onChange={({ value }) => handleChangingDosageUnit(value)}
                placeholder={t("select")}
                className="custom-select"
                classNamePrefix="custom-select"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntakesFrequencyAndDosageUnit;
